import app from '../app';
import type Mithril from 'mithril';
import User from '../models/User';

/**
 * The `dan` helper displays a user's dan in a <span className="username">
 * tag. If the user doesn't exist, the dan will be displayed as [deleted].
 */
export default function dan(user: User | null | undefined | false): Mithril.Vnode {
  const dan = (user && user.dan()) || 0;

  return <span className="username">{dan}</span>;
}